import React, { lazy, Suspense } from 'react';
import IAppFormContainerProps from './entities/IProps';
import { injectSaga } from '../../../app-init';
import { lazyRetry } from '@bimser/core';
import { ModuleImporter } from '../../../helpers/sdk/ModuleImporter';
import { ProjectHelper } from '@bimser/common';
import { BCLoading } from '@bimser/components';

const AppFormContainerLazy = lazy(() =>
	lazyRetry(() => import(/* webpackChunkName: "web-form-viewer" */ './containers'))
);

function AppFormContainer(props: React.PropsWithChildren<IAppFormContainerProps>) {
	return (
		<Suspense
			fallback={
				<BCLoading
					show
					center
					style={{ width: '100%', height: '100%' }}
				/>
			}
		>
			<AppFormContainerLazy {...props} />
		</Suspense>
	);
}
AppFormContainer.onPanelOpening = props => {
	const { projectName, packageVersion } =
		props.componentProps[0].props.childFormData || props.componentProps[0].props;
	const sdkVersion = ProjectHelper.getTargetAgentProject(projectName, packageVersion).sdkVersion;

	const formControlsPromise = ModuleImporter(sdkVersion)
		.SDK()
		.Helpers()
		.then(({ FormControlsSagas }) => {
			injectSaga('form-controls', FormControlsSagas.rootSaga);
		});

	const appFormPromise = lazyRetry(() =>
		import(/* webpackChunkName: "web-form-viewer" */ './sagas').then(({ default: saga }) => {
			injectSaga('appForm', saga);
		})
	);

	return Promise.all([formControlsPromise, appFormPromise]);
};

export default AppFormContainer;
